




























import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import FactorScoringDefinitionCreator from "@/components/scoring-definition/FactorScoringDefinitionCreator.vue";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import Choices from "@/store/modules/Choices";
import Decisions from "@/store/modules/Decisions";
import ScoringKeys from "@/store/modules/ScoringKeys";
import Dialogs from "@/store/modules/Dialogs";
import Modelling from "@/store/modules/Modelling";
import { Factor } from "@/api/model/FactorResource";
import Scoring from "@/store/modules/Scoring";

const modellingModule = getModule(Modelling)
const choicesModule = getModule(Choices)
const decisionsModule = getModule(Decisions)
const viewpointModule = getModule(Viewpoints);
const scoringKeysModule = getModule(ScoringKeys)
const dialogsModule = getModule(Dialogs)
@Component({
    components: {FactorScoringDefinitionCreator}
})
export default class FactorScoringDefinitionCreatorVuexDialog extends Vue {

    private scoringDefinition = null;
    private submitting = false;
    private open = false;

    get viewpointId() {
        if (this.selectedScoringDefinitionEdit) return this.selectedScoringDefinitionEdit.viewpointId;
    }

    get factorId() {
        if (this.selectedScoringDefinitionEdit) return this.selectedScoringDefinitionEdit.resourceId;
    }

    @Watch('factorId')
    @Watch('viewpointId')
    private onIdChanges() {
        if (this.factorId && this.viewpointId) {
            this.open = true;
        } else {
            this.open = false;
        }
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectedScoringDefinitionEdit() {
        return dialogsModule.selectedScoringDefinitionEdit
    }

    get factorScoringDefinition() {
        if (this.viewpointFactor) {
            return JSON.parse(JSON.stringify(this.viewpointFactor)).scoringDefinition;
        }
        let factor = this.factorResources[this.factorId] as Factor
        if(this.factor.scoringDefinition) {
            return JSON.parse(JSON.stringify(this.factor)).scoringDefinition
        }
        return {};
    }

    set factorScoringDefinition(scoringDefinition: any) {
        if (!this.viewpointId || !this.factorId) return;

        this.submitting = true;
        Promise.all(scoringDefinition.factors.map(async (id) => {
            let payload = {
                viewpointId: this.viewpointId,
                factorResourceId: id,
                scoringDefinition: scoringDefinition,
            }
            return viewpointModule.updateViewpointFactorResourceScoringDefinition(payload)
        })).then(() => {
            this.submitting = false;
            if (decisionsModule.selectedDecisionId && this.viewpointId && scoringDefinition && scoringDefinition.type !== 'MANUAL') {
                let modelDefinition = getModule(Modelling).publishedDecisionModelDefinition;
                if (modelDefinition) {
                    getModule(Scoring).getScoresForViewpoint({
                        decisionId: decisionsModule.selectedDecisionId,
                        revision: modelDefinition.revision,
                        viewpointId: this.viewpointId
                    })
                }
            }
            dialogsModule.editScoringDefinition(null)
        }).catch(err => {
            this.submitting = false;
            dialogsModule.editScoringDefinition(null)
        })
    }

    get viewpointFactor() {
        if (!this.viewpointId || !this.factorId) return;
        return viewpointModule.viewpointFactorResources[this.viewpointId][this.factorId]
    }

    get factor() {
        if (!this.viewpointId || !this.factorId) return;
        return modellingModule.publishedModelFactorResources[this.factorId] as Factor
    }

    get dataField() {
        if (this.factor) {
            return this.factor.dataField;
        }
    }

    get valueType() {
        if (this.factor && this.factor.valueTypeDefinition) {
            return this.factor.valueTypeDefinition.valueType;
        }
    }

    get choiceValues() {
        if (this.dataField) {
            return choicesModule.choicesList
                .filter((c: any) => this.dataField && c[this.dataField])
                .map((c: any) => c[this.dataField || ''])
        }
        return [];
    }

    get defaultScoringKeys() {
        if (!this.viewpointId || !this.factorId) return;
        if (scoringKeysModule.viewpointScoringKeyDefinitions[this.viewpointId]) {
            return scoringKeysModule.viewpointScoringKeyDefinitions[this.viewpointId][this.factorId];
        }

        let factor = this.factorResources[this.factorId] as Factor
        if(factor.scoringDefinition) {
            return this.factor.scoringDefinition
        }
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources
    }

    //Get the inherited text name for display. Where the scoring key was inherited from
    // This is not the most ideal solution but until I think of a better scoring key refactor, this is
    // what I am going to go with since it is only ever really done in one or two places
    get inheritedFromName() {
        if (!this.defaultScoringKeys || !this.defaultScoringKeys.inheritedFrom || !this.viewpointId || !this.factorId) {
            return;
        }
        let inheritedFrom = this.defaultScoringKeys.inheritedFrom;
        let inheritedFromResourceId = this.defaultScoringKeys.inheritedFromResourceId
        
        if(inheritedFromResourceId && inheritedFromResourceId != "M") {
            return `GROUP (${this.factorResources[inheritedFromResourceId].name})`
        }
        if (inheritedFrom === 'VIEWPOINT' && viewpointModule.selectedViewpointsMap && viewpointModule.selectedViewpointsMap[this.viewpointId]) {
            return `Viewpoint (${viewpointModule.selectedViewpointsMap[this.viewpointId].name})`;
        } else if (inheritedFrom === 'DECISION' && decisionsModule.selectedDecision) {
            return `Decision (${decisionsModule.selectedDecision.name})`
        } else if (inheritedFromResourceId) {
            return `Section (${modellingModule.publishedModelFactorResources[inheritedFromResourceId].name})`;
        }
    }

    get allDataPresent() {
        return this.valueType != null
            && this.dataField != null
    }

    private async cancel() {
        await dialogsModule.editScoringDefinition(null)
    }

}
